// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ReactUseIntercom = require("./ReactUseIntercom");

function useIntercom(prim) {
  return ReactUseIntercom.useIntercom();
}

function isBannerVisible() {
  return Core__Option.isSome(Caml_option.nullable_to_opt(document.querySelector("iframe[name=\"intercom-banner-frame\"]")));
}

exports.useIntercom = useIntercom;
exports.isBannerVisible = isBannerVisible;
/* ./ReactUseIntercom Not a pure module */
